import { inject, Injectable } from '@angular/core';
import { User } from '@common/models/user';
import { UserService } from '@services/user.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    private userService = inject(UserService);

    private currentUser: User;
    private isAuthenticated: boolean;

    constructor() {
        this.userService.currentUserSubject.subscribe((user) => (this.currentUser = user));
        this.userService.isAuthenticatedSubject.subscribe(
            (isAuthenticated) => (this.isAuthenticated = isAuthenticated)
        );
    }

    async canActivate() {
        if (!this.currentUser) {
            this.currentUser = await this.userService.getCurrentUser();
        }

        return this.isAuthenticated;
    }

    canActivateChild() {
        return this.canActivate();
    }
}
